export enum ActivationStatus {
    Draft = 1,
    SubmittedNotLiveYet = 3,
    Live = 4,
    TrackingClose = 5,
    Archived = 6,
    NA = 7
}
